import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46aec48e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "default_box" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "default_content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: 'https://image.kilimall.com/kenya/new_wap/voucher/voucher_empty@2x.png'.webpFilters()
,
      alt: ""
    }, null, 8, _hoisted_2),
    _createElementVNode("p", null, _toDisplayString($props.title), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString($props.content), 1)
  ]))
}